import { Nav } from './components/Nav'
import { Hero } from './components/Hero'
import { MarqueeBand } from './components/Marquee'
import { Services } from './components/Services'
import { Projects } from './components/Projects'
import { WhyUs } from './components/WhyUs'
import { Process } from './components/Process'
import { TechStack } from './components/TechStack'
import { Calculator } from './components/Calculator'
import { BookCall } from './components/BookCall'
import { Faq } from './components/Faq'
import { FinalCta } from './components/FinalCta'
import { Footer } from './components/Footer'
import { useScrollReveal } from './hooks/useScrollReveal'

function App() {
  useScrollReveal()

  return (
    <>
      <a href="#main" className="skip-link">Skip to content</a>
      <Nav />
      <main id="main">
        <Hero />
        <MarqueeBand />
        <Services />
        <Projects />
        <WhyUs />
        <Process />
        <TechStack />
        <Calculator />
        <BookCall />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </>
  )
}

export default App
